import "./Home.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UsersGif from "./../../assets/users-gif.gif";
import FactoriesGif from "./../../assets/factories-gif.gif";
import FactoriesProductsGif from "./../../assets/factories-products-gif.gif";
import ShopsGif from "./../../assets/shops-gif.gif";
import CartGif from "./../../assets/cart-gif.gif";
import UserPassword from "./../../assets/user-password.svg";
import ShowUser from "./../../assets/show-user.svg";
import EditUser from "./../../assets/edit-user.svg";
import DeleteUser from "./../../assets/delete.svg";
import { DataGrid } from "@mui/x-data-grid";
import { HomeColumns } from "../../SourceData";
import { message } from "antd";
import MessageModals from "../../components/MessageModals/MessageModals";
import SwipeableModals from "./SwipeableModals/SwipeableModals";
import api from "../../utils/api";
import SwitchButton from "../../components/SwitchButton/SwitchButton";
import usePermissions from "../../hooks/usePermissions";

const Home = () => {
  const [homeData, setHomeData] = useState([]);
  const [currentModalView, setCurrentModalView] = useState("changePassword");
  const [openDelete, setOpenDelete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const { hasPermission } = usePermissions(); // Initialize the hook and destructure the hasPermission function

  const handleOpen = (view) => {
    setCurrentModalView(view);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/dash");
      setHomeData(res.data.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
      setUser("");
    }
  };

  const handleActive = async (id) => {
    setLoading(true);
    try {
      await api.put(`/users/${id}/activateToggle`);
      getData();
      message.success("تم تعديل حالة المستخدم بنجاح");
    } catch (error) {
      console.error("Error toggling user status:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionColumn = [
    {
      field: "active",
      headerName: "الحالة",
      minWidth: 40,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const isActive = params?.row?.active === 1;
        return (
          <SwitchButton
            checked={isActive}
            onClick={() => handleActive(params.row.id)}
          />
        );
      },
    },
    {
      field: "action",
      headerName: "",
      width: 180,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,

      renderCell: (params) => {
        return (
          <div className="cell-action">
            <div
              className="cell-btn"
              onClick={() => {
                setUser(params.row);
                handleOpen("changePassword");
              }}
            >
              <img src={UserPassword} alt="" />
            </div>

            <Link className="cell-btn" to={`/users/${params.row.id}`}>
              <img src={ShowUser} alt="" />
            </Link>

            <div
              className="cell-btn"
              onClick={() => {
                setUser(params.row);
                handleOpen("editUser");
              }}
            >
              <img src={EditUser} alt="" />
            </div>

            <div
              className="cell-btn"
              onClick={() => {
                setOpenDelete(true);
                setUser(params.row);
              }}
            >
              <img src={DeleteUser} alt="" />
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="home">
      <div className="widgets">
        {/* Users count widget */}
        {hasPermission(3) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={UsersGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.users_count}</p>
              {/* <span className="percentage">25%+</span> */}
            </div>
            <span className="widget-title">عدد المستخدمين</span>
          </Link>
        )}

        {/* Factories count widget */}
        {hasPermission(6) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#FEEEF6" }}
            >
              <img src={FactoriesGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.factories_count}</p>
            </div>
            <span className="widget-title">عدد المصانع</span>
          </Link>
        )}

        {/* Factory products count widget */}
        {hasPermission(7) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.products_for_factories_count}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد منتجات المصانع</span>
          </Link>
        )}

        {/* Shops count widget */}
        {hasPermission(4) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#FFF6EB" }}
            >
              <img src={ShopsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.shops_count}</p>
              {/* <span className="percentage">15%+</span> */}
            </div>
            <span className="widget-title">عدد المتاجر</span>
          </Link>
        )}

        {/* Shop products count widget */}
        {hasPermission(5) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.products_for_shops_count}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد منتجات المتاجر</span>
          </Link>
        )}

        {/* Current orders count widget */}
        {hasPermission(8) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.current_orders_count}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد الطلبات الحالية</span>
          </Link>
        )}

        {/* Expired orders count widget */}
        {hasPermission(10) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#ECF9FF" }}
            >
              <img src={FactoriesProductsGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.expired_orders_count}</p>
              {/* <span className="percentage">10%+</span> */}
            </div>
            <span className="widget-title">عدد الطلبات المنتهية</span>
          </Link>
        )}

        {/* Rejected orders count widget */}
        {hasPermission(11) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#F1EDFE" }}
            >
              <img src={CartGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.rejected_orders_count}</p>
            </div>
            <span className="widget-title">عدد الطلبات الملغية</span>
          </Link>
        )}

        {/* Expired products count widget */}
        {hasPermission(9) && (
          <Link className="widget">
            <div
              className="icon-container"
              style={{ backgroundColor: "#F1EDFE" }}
            >
              <img src={CartGif} alt="" className="widget-icon" />
            </div>
            <div className="widget-text-container">
              <p className="number">{homeData?.expired_products_count}</p>
            </div>
            <span className="widget-title">عدد المنتجات المنتهية</span>
          </Link>
        )}
      </div>

      {/* Latest users section */}
      {hasPermission(13) && (
        <>
          <h4>المستخدمين المنضمين حديثاً</h4>

          <DataGrid
            sx={{ backgroundColor: "white", width: "100%" }}
            autoHeight={true}
            columns={HomeColumns.concat(actionColumn)}
            rows={homeData?.latest_users?.map((row, index) => {
              return { ...row, index: index + 1 };
            })}
            disableVirtualization
            disableColumnFilter
            disableColumnMenu
            loading={loading}
            hideFooter
          />

          <MessageModals
            open={openDelete}
            currentView="delete"
            route={`/users/${user.id}`}
            onClose={() => {
              setOpenDelete(false);
            }}
            onDataChange={getData}
          />

          <SwipeableModals
            open={isOpen}
            onClose={handleClose}
            onOpen={handleOpen}
            currentView={currentModalView}
            user={user}
            onDataChange={getData}
          />
        </>
      )}
    </div>
  );
};

export default Home;
